var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 21.3333H29.6666V24H0.333252V21.3333H2.99992V1.33333C2.99992 0.979711 3.14039 0.640573 3.39044 0.390524C3.64049 0.140476 3.97963 0 4.33325 0H17.6666C18.0202 0 18.3593 0.140476 18.6094 0.390524C18.8594 0.640573 18.9999 0.979711 18.9999 1.33333V21.3333H21.6666V8H25.6666C26.0202 8 26.3593 8.14048 26.6094 8.39052C26.8594 8.64057 26.9999 8.97971 26.9999 9.33333V21.3333ZM8.33325 10.6667V13.3333H13.6666V10.6667H8.33325ZM8.33325 5.33333V8H13.6666V5.33333H8.33325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIcon2);
export default __webpack_public_path__ + "static/media/tab-icon2.7b5f5f9d025cf96e0ba618ed02861756.svg";
export { ForwardRef as ReactComponent };